import { MapView } from './components/MapView'
import { TimePanel } from './components/TimePanel'
import { LocationPanel } from './components/LocationPanel'

export default function App() {
  return (
    <div className="relative h-full w-full overflow-hidden">
      <MapView />

      {/* Soft vignette only at edges — map stays readable in the center */}
      <div className="pointer-events-none absolute inset-0 z-10 bg-gradient-to-b from-black/15 via-transparent to-black/20" />

      <header className="pointer-events-none absolute top-0 left-0 right-0 z-20 p-4 md:p-6 flex items-start justify-between gap-4">
        <div className="pointer-events-auto">
          <h1
            className="text-3xl md:text-4xl font-bold tracking-tight text-white drop-shadow-lg"
            style={{ fontFamily: 'var(--font-display)' }}
          >
            SunScout
            <span className="text-[var(--accent)]"> 3D</span>
            <span className="ml-2 text-xs font-medium text-white/45 align-middle">v1.4.4</span>
          </h1>
          <p className="text-sm text-white/75 max-w-md mt-1">
            Planuj ujęcia ze światłem słonecznym i cieńmi realnej zabudowy OSM.
          </p>
        </div>
      </header>

      <div className="pointer-events-none absolute inset-x-0 bottom-0 z-20 p-3 md:p-5 flex flex-col md:flex-row gap-3 md:items-end md:justify-between">
        <div className="pointer-events-auto w-full md:w-auto md:max-w-sm order-2 md:order-1">
          <LocationPanel />
        </div>
        <div className="pointer-events-auto w-full md:flex-1 md:max-w-xl order-1 md:order-2 md:ml-auto">
          <TimePanel />
        </div>
      </div>
    </div>
  )
}
